import React from 'react';
import TurnosClub from '../../club/turnos/turnosClub';

const AgendaGestion = () => {
  return (
    <TurnosClub
      soloLectura
      titulo="Agenda"
    />
  );
};

export default AgendaGestion;
